/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=b1955dc6&lang=stylus"

const __exports__ = script;

export default __exports__